module.exports = __webpack_public_path__ + "img/P8.797a45c3.jpg";